module.exports = __webpack_public_path__ + "img/unibanco.c251d6a5.svg";